import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { map, Observable, switchMap, tap } from "rxjs";

import { AccountService } from "@bitwarden/common/auth/abstractions/account.service";
import { getUserId } from "@bitwarden/common/auth/services/account.service";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import { Utils } from "@bitwarden/common/platform/misc/utils";
import { ProviderService, Provider } from "@bitwarden/common/provider";
import { AvatarComponent, ContainerComponent, TableModule } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";
import { HeaderModule } from "@bitwarden/web-vault/app/layouts/header/header.module";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-providers",
  templateUrl: "providers.component.html",
  imports: [
    CommonModule,
    RouterLink,
    ContainerComponent,
    AvatarComponent,
    TableModule,
    I18nPipe,
    HeaderModule,
  ],
})
export class ProvidersComponent implements OnInit {
  providers$?: Observable<Provider[]>;
  loaded = false;

  constructor(
    private providerService: ProviderService,
    private i18nService: I18nService,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    document.body.classList.remove("layout_frontend");
    this.load();
  }

  load() {
    this.providers$ = this.accountService.activeAccount$.pipe(
      getUserId,
      switchMap((userId) => this.providerService.providers$(userId)),
      map((p) => p.sort(Utils.getSortFunction(this.i18nService, "name"))),
      tap(() => (this.loaded = true)),
    );
  }
}
